import {
  BarChart3,
  Brush,
  Briefcase,
  CalendarDays,
  ClipboardCheck,
  ClipboardList,
  FileText,
  Film,
  Gauge,
  Globe2,
  Inbox,
  KeyRound,
  LayoutDashboard,
  LineChart,
  Link2,
  ListTree,
  MapPin,
  MessageSquareWarning,
  MessagesSquare,
  Network,
  Package,
  Palette,
  Radar,
  Receipt,
  CreditCard,
  ScanFace,
  Scissors,
  ShoppingCart,
  Smartphone,
  Store,
  UserPlus,
  SwatchBook,
  UserCheck,
  UserCog,
  UserSearch,
  Users,
  Workflow,
} from "lucide-react";

/** Distinct sidebar icon per overview card id (workspace + partner). */
const ICON_BY_CARD_ID = {
  "network-dashboard": LayoutDashboard,
  "network-kpis": LineChart,
  "salon-dashboard": Store,
  "salon-kpis": Gauge,

  "skin-funnel": ScanFace,
  "skin-services": ClipboardList,
  "skin-network-kpis": Network,

  "hair-funnel": Brush,
  "hair-services": Scissors,

  "check-ins": UserCheck,
  "engagement-appointments": CalendarDays,
  "visit-services": ClipboardCheck,
  "customers": Users,
  "check-in-analytics": BarChart3,
  "customer-analytics": UserSearch,
  "staff-report": UserCog,
  "staff-analytics": UserCog,
  "flow-all": Workflow,
  engagement: MessagesSquare,
  "demo-engagement": MessagesSquare,
  reels: Film,
  "reels-app": Smartphone,

  "price-list": Receipt,
  "product-list": Package,
  "my-orders": ShoppingCart,
  staff: Briefcase,
  "staff-availability": Briefcase,
  apps: Smartphone,
  "kiosk-login": KeyRound,
  "dashboard-staff": UserPlus,

  "franchise-users": UserPlus,
  regions: Globe2,
  licenses: KeyRound,
  plans: CreditCard,
  complaints: MessageSquareWarning,
  "contact-inbox": Inbox,
  "location-requests": MapPin,
  "geofence-settings": Radar,

  "exec-dashboard": LayoutDashboard,
  "customer-analytics": UserSearch,
  "hq-admins": UserCog,
  "company-profile": Store,
  invoices: Receipt,

  "kiosk-register-forms": FileText,
  "page-setup": Palette,
  "franchise-themes": SwatchBook,

  "skin-settings": ScanFace,
  "service-list-mapped": Link2,
  "service-list-management": ListTree,
};

export function iconForOverviewCard(_sectionId, cardId) {
  return ICON_BY_CARD_ID[cardId] || LineChart;
}
